import Vue from 'vue';
import Vuex from 'vuex';

// we first import the module
import surveys from './surveys';
import questions from './questions';
import filters from './filters';
import travellyze from './travellyze';
import buyerPersonas from './buyerPersonas';
import demographics from './demographics';
import countries from './countries';
import auth from './auth';
import * as Sentry from '@sentry/vue';

Vue.use(Vuex);

export default function (/* { ssrContext } */) {
  if (!process.env.DEV) {
    Sentry.init({
      Vue,
      dsn: 'https://37d87c79004ec1d559251382d63aa456@o4509006895382528.ingest.de.sentry.io/4509006898921552',
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false
        })
      ],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: ['https://advanced.travellyze.com']
    });
  }

  const Store = new Vuex.Store({
    modules: {
      // then we reference it
      surveys,
      questions,
      filters,
      travellyze,
      buyerPersonas,
      demographics,
      countries,
      auth
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV
  });

  /*
    if we want some HMR magic for it, we handle
    the hot update like below. Notice we guard this
    code with "process.env.DEV" -- so this doesn't
    get into our production build (and it shouldn't).
  */

  if (process.env.DEV && module.hot) {
    module.hot.accept(['./surveys'], () => {
      const newShowcase = require('./surveys').default;
      Store.hotUpdate({ modules: { surveys: newShowcase } });
    });
    module.hot.accept(['./questions'], () => {
      const newShowcase = require('./questions').default;
      Store.hotUpdate({ modules: { questions: newShowcase } });
    });
    module.hot.accept(['./travellyze'], () => {
      const newShowcase = require('./travellyze').default;
      Store.hotUpdate({ modules: { travellyze: newShowcase } });
    });
    module.hot.accept(['./filters'], () => {
      const newShowcase = require('./filters').default;
      Store.hotUpdate({ modules: { filters: newShowcase } });
    });
    module.hot.accept(['./demographics'], () => {
      const newShowcase = require('./demographics').default;
      Store.hotUpdate({ modules: { demographics: newShowcase } });
    });
    module.hot.accept(['./countries'], () => {
      const newShowcase = require('./countries').default;
      Store.hotUpdate({ modules: { countries: newShowcase } });
    });
    module.hot.accept(['./auth'], () => {
      const newShowcase = require('./auth').default;
      Store.hotUpdate({ modules: { auth: newShowcase } });
    });
    module.hot.accept(['./buyerPersonas'], () => {
      const newShowcase = require('./buyerPersonas').default;
      Store.hotUpdate({ modules: { auth: newShowcase } });
    });
  }

  return Store;
}
